import React from "react";
import { ResourceDescriptor } from "./common";
import { default as MUIPasswordField, PasswordFieldProps } from "../components/PasswordField";

const change_password: ResourceDescriptor = {
    url: "change_password",
    orders: {
        create: ["current_password", "new_password", "retype_password"],
    },
    crudActions: ["create"],
    muiRenderers: {
        create: {
            current_password: React.forwardRef<HTMLDivElement, PasswordFieldProps>((props, ref) => (
                <MUIPasswordField {...props} autoComplete="current-password" autoFocus={true} ref={ref} />
            )),
            new_password: React.forwardRef<HTMLDivElement, PasswordFieldProps>((props, ref) => (
                <MUIPasswordField {...props} autoComplete="new-password" ref={ref} />
            )),
            retype_password: React.forwardRef<HTMLDivElement, PasswordFieldProps>((props, ref) => (
                <MUIPasswordField {...props} autoComplete="new-password" ref={ref} />
            )),
        },
    },
    resourceSchemaPostProcessor: (schema) => {
        schema["retype_password"] = {
            default: null,
            required: false,
            type: {
                name: "String",
            },
            name: "retype_password",
            validators: [
                {
                    params: { passwordFieldName: "new_password" },
                    name: "passwordMatch",
                    key: "passwordMatch_error",
                },
            ],
        };
    },
};

export default change_password;
